<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0" [formGroup]="courseRegistrationForm">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                    {{title}}
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    {{title}} - Details
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ">
                                            <hr>
                                        </div>
                                        <div class="col-md-8 ">
                                            <div class="cutom p-3 mb-3">
                                              <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_one}} </b></p>
                                                <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_two}} </b></p>
                                                <p class="main-content-title card-sub-title f20 mb-0"><b>{{title_three}}</b></p> 
                                            </div>
                                        </div>
                                        <div class="col-md-4 pt-4 mrrr">
                                            <mat-form-field appearance="outline" class="example-full-width mt-2 " >
                                                <mat-label>Search</mat-label>
                                                <input class="color" matInput placeholder="Search Records" 
                                                    (keyup)="keypress()">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                        
                                    </div>
                                    <hr>
                                    <div class="table-responsive">
                                        <table 
                                            class="table table-striped table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th width="5%" class="f600">
                                                       Id
                                                    </th>
                                                    <th width="15%" class="f600">
                                                        Course
                                                    </th>
                                                    <th width="50%"  class="f600">
                                                        Name
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        New Recs
                                                    </th>
                                                    <th width="10%" class="f600">
                                                        Open Lists
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="courseList.length > 0">
                                                <tr *ngFor="let course of courseList;" (click)="prepopulate(course)">
                                                    <!-- (click)="loadBranchList(course,MenuCode)" -->
                                                    <td> {{course.CShId}} </td>
                                                    <td>{{course.CShCoCode}} </td>
                                                    <td> {{course.CoName}} </td>
                                                    <td>{{course.NotAss}} </td>
                                                    <td>{{course.NotUpdt}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-sm-7">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>Course</mat-label>
                                                        <input formControlName="Course" readonly onkeydown="return (event.keyCode!=13);" class="color" matInput 
                                                            placeholder="Course Name" required>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-5">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width" >
                                                        <mat-label>College Code</mat-label>
                                                        <input formControlName="Scope" onkeydown="return (event.keyCode!=13);" class="color" matInput 
                                                            placeholder="College Code" required>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-sm-12 prpl">

                                                <button type="button"  *ngIf="submitButton" 
                                                class="btn sz1 btn-primary btn-icon-text floatright mt-1 fr">
                                                <span style="display: contents; align-items: center;" >
                                                    <img width="20vh" src="../../assets/img/exit.gif" style="margin-right: 5px;">
                                                     Exit
                                                </span>
                                                </button> 
                                                <button type="button" *ngIf="submitButton && GenerateRegnNoCreate"
                                                class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                 (click)="ValidateAndProcess()">
                                                <span style="display: contents; align-items: center;">
                                                     <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                                     Process
                                                </span> 
                                                </button>
                                            </div>
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    </body>
    